import { useCallback, useState } from 'react'
import AnmeldeForm from './AnmeldeForm'
import Ausweis from './Ausweis'
import { Etikett, Wabennetz } from './Bausteine'
import { anmeldung } from '@/data/inhalte'
import { leereWerte, type FormWerte } from '@/lib/pruefung'

/** Anmeldung: links der Zugangsausweis, der sich beim Tippen fuellt, rechts das Formular. */
export default function Anmeldung() {
  const [werte, setWerte] = useState<FormWerte>(leereWerte)
  const [angemeldet, setAngemeldet] = useState(false)
  const beiAenderung = useCallback((w: FormWerte) => setWerte(w), [])
  const name = `${werte.vorname} ${werte.nachname}`.trim()

  return (
    <section id="anmeldung" className="verlauf-konferenz relative isolate overflow-hidden py-20 text-white sm:py-28">
      <Wabennetz className="h-[45%]" staerke={0.28} />
      <div className="huelle">
        <Etikett aufDunkel>{anmeldung.etikett}</Etikett>
        <div className="mt-10 flex flex-wrap items-end justify-between gap-6">
          <h2 className="text-[clamp(36px,5vw,64px)]">{anmeldung.titel}</h2>
          <p className="max-w-[38ch] text-[18px] text-white/85">{anmeldung.text}</p>
        </div>
        <div className="mt-12 grid gap-12 lg:grid-cols-[0.85fr_1.15fr] lg:items-start lg:gap-16">
          <div className="lg:sticky lg:top-24">
            <Ausweis name={name} organisation={werte.organisation.trim()} branche={werte.branche} funktion={werte.funktion} angemeldet={angemeldet} />
          </div>
          <AnmeldeForm beiAenderung={beiAenderung} beiErfolg={() => setAngemeldet(true)} />
        </div>
      </div>
    </section>
  )
}
